"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FileAssetViewer = exports.FileAssetViewerDefaultProps = exports.PLAIN_TYPES = exports.OFFICE_TYPES = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var window_size_1 = require("@react-hook/window-size");
var lodash_1 = require("lodash");
exports.OFFICE_TYPES = ["application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document", "application/vnd.openxmlformats-officedocument.presentationml.presentation", "application/vnd.ms-powerpoint", "application/vnd.ms-excel", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"];
exports.PLAIN_TYPES = ["application/pdf"];
exports.FileAssetViewerDefaultProps = {};
// -------- Child Component Props -------->
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var FrameStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    border: none;\n  "], ["\n    border: none;\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Frame: styled_components_1.default.iframe(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), FrameStyles)
};
var FileAssetViewer = function (props) {
  var className = props.className,
    entity = props.entity;
  var file = entity.file;
  var height = (0, window_size_1.useWindowHeight)();
  var width = (0, window_size_1.useWindowWidth)();
  var isOffice = (0, lodash_1.includes)(exports.OFFICE_TYPES, file.type);
  var frameSrc = isOffice ? "https://view.officeapps.live.com/op/embed.aspx?src=".concat(encodeURIComponent(file.url)) : file.url;
  var id = isOffice ? "msdoc-iframe" : 'doc-frame';
  var title = isOffice ? "msdoc-iframe" : '';
  return react_1.default.createElement(My.Container, null, react_1.default.createElement(My.Frame, {
    width: width - 60,
    height: height - 140,
    src: frameSrc,
    id: id,
    title: title,
    frameBorder: "0"
  }));
};
exports.FileAssetViewer = FileAssetViewer;
exports.FileAssetViewer.defaultProps = exports.FileAssetViewerDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;